import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { useQueries } from 'react-query';

import type { ApiError } from '~/lib/api';
import type { IApiGetDocumentResponseBody } from '../DocumentsApi.types';
import type { IUseDocumentQueryValues } from './useDocumentQuery';
import { useApi } from '~/lib/api/useApi';
import { documentQueryKeyFactory } from './useDocumentQuery';

export const useDocumentsQueries = (
  valuesList?: Array<IUseDocumentQueryValues>,
  options?: UseQueryOptions<IApiGetDocumentResponseBody, ApiError>,
): Array<UseQueryResult<IApiGetDocumentResponseBody, ApiError>> => {
  const api = useApi();

  return useQueries(
    valuesList?.map(
      (values) =>
        values && {
          queryKey: documentQueryKeyFactory(values),
          queryFn: values
            ? () => api.documents.get(values.appId, values.documentId)
            : undefined,
          enabled: !!values,
          ...options,
        },
    ) ?? [],
  );
};
